import "@rmlibrary/scroll";
import "./cjs-animations";
import "./common";
import "./accordion";

import { debounce, getLanguage, getValueFromInput, isInteger } from "./utilities";
import { generatePDF, setupPreview } from "./pdf";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import { RMNumberInput } from "@rmlibrary/inputs";
import { cjsStarted } from "./cjs-animations";
import { getVolatilityResults } from "./calculations";
import { storePrintValues } from "./storage";

const lang = getLanguage();
const formatter = new Formatter(lang);
const printReportButton = $("#print-btn");
const pdfReportButton = $("#pdf-btn");
let graph = null;
let calculatedResults = null;
let graphWidth = $(".graph-container").width();
let animating = false;
let isGraphLoaded = false;
printReportButton.prop("disabled", true);
pdfReportButton.prop("disabled", true);

function setUpButtons() {
    printReportButton.on("click", (event) => {
        if (isGraphLoaded & !$(".err-msg").is(":visible")) {
            updatePrintValues();
            window.open("print.html");
        } else {
            event.preventDefault();
        }
    });

    pdfReportButton.on("click", (event) => {
        if (isGraphLoaded & !$(".err-msg").is(":visible")) {
            const startingAmount = formatter.formatCurrency(formatter.parseNumber($("#start-amount").val()));
            const graphSrc = $("canvas").get(0).toDataURL();
            const format = lang === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
            const date = formatter.formatDate(new Date(), format);
            $(".graph").attr("src", graphSrc);
            $(".starting-amount").text(startingAmount);
            $(".current-date").text(date);
            generatePDF();
        } else {
            event.preventDefault();
        }
    });
}

function setUpNumericInputs() {
    const startingAmountEl = document.getElementById("start-amount");

    RMNumberInput(startingAmountEl, { inputmode: "numeric" });

    $("#start-amount").on("focus", function () {
        const value = formatter.parseNumber($(this).val());
        $(this).val(value).trigger("select");
    });

    $("#start-amount").on("keyup", ({ target }) => {
        const input = $(target);

        input.val(input.val().replace(/\D/g, ""));
    });
}

function fillFieldsOnBlur() {
    // Ensures that inputs are not blank if user deletes number, fills input with 0
    $("#start-amount").on("blur", () => {
        const value = document.getElementById("start-amount").value || 0;
        $("#start-amount").val(formatter.formatNumber(value));
        setInputMaxLength();
    });
}

export function buildVolatility() {
    const volatilityForm = document.getElementById("volatility-form")
        ? document.getElementById("volatility-form")
        : null;

    // Set up event handler if form on page
    if (volatilityForm) {
        volatilityForm ? volatilityForm.addEventListener("submit", submitVolatilityStartAmount, false) : null;
    }
}

function disableFormSubmitOnEnter() {
    $("#volatility-form").on("keyup keypress", (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });
}

function submitVolatilityStartAmount() {
    let startAmount = formatter.parseNumber($("#start-amount").val());

    if (startAmount > 1000000 || startAmount < 1 || isNaN(startAmount) || !isInteger(startAmount)) {
        $(".volatility-err").show();
        startAmount = 0;
    } else {
        animating = true;
        isGraphLoaded = false;
        printReportButton.prop("disabled", true);
        pdfReportButton.prop("disabled", true);

        $(".volatility-err").hide();

        // Get results from volatility.js
        const volatilityPromise = new Promise((resolve) => {
            getVolatilityResults(resolve, startAmount);
        });
        // Print results on screen once promise is returned
        volatilityPromise.then((results) => {
            calculatedResults = results;
            const stackValues = {
                stack1: Math.round((results.stack1 / results.stack4) * 35) || 0,
                stack2: Math.round((results.stack2 / results.stack4) * 35) || 0,
                stack3: Math.round((results.stack3 / results.stack4) * 35) || 0,
                stack4: Math.round((results.stack4 / results.stack4) * 35) || 0 // ensuring that it returns a NaN on empty input
            };

            const volatilityEl = document.querySelector('[cjs-animation="animate/volatility_graph"]');
            const canvasEl = volatilityEl.querySelector("canvas");
            canvasEl.setAttribute(
                "aria-label",
                lang === "en" ? "The value of staying invested" : "L'importance de maintenir ses placements"
            );
            cjsStarted(volatilityEl).then(() => {
                graph = volatilityEl.cjsAnimation.exportRoot;

                if (lang === "fr") {
                    graph.xAxis.continuously.font = "14px 'Roobert-medium'";
                    graph.xAxis.continuously.lineHeight = 21;
                    graph.xAxis.continuously.lineWidth = 150;
                    graph.xAxis.continuously.text = "Si vous maintenez vos placements";
                }

                Promise.all(
                    Object.keys(stackValues).map(
                        (stack) =>
                            new Promise((resolve) => {
                                if (isNaN(stackValues[stack])) {
                                    resolve();
                                } else {
                                    const stackClip = graph[stack];
                                    const oldStop = stackClip.stop;
                                    stackClip.stop = function () {
                                        if (this.currentFrame > 0) setTimeout(resolve, 900);
                                        oldStop.call(this);
                                        this.stop = oldStop;
                                    };
                                    stackClip.coinArray = [];
                                    stackClip.stackValue = stackValues[stack];
                                    stackClip.labelAnimation.label.txt.text = "";
                                    const amountFontSize = graphWidth < 400 ? 22 : 18;
                                    stackClip.labelAnimation.label.txt.font = `bold ${amountFontSize}px Roobert-bold`;
                                    stackClip.gotoAndPlay(1);
                                }
                            })
                    )
                ).then(() => {
                    for (let stack in stackValues) {
                        var stackClip = volatilityEl.cjsAnimation.exportRoot[stack];
                        stackClip.labelAnimation.y = stackClip.children[stackClip.children.length - 2].instance.y - 70;
                        stackClip.labelAnimation.label.txt.text = formatter.formatCurrency(results[stack], 0);
                        stackClip.labelAnimation.gotoAndPlay(0);
                        animating = false;
                        setTimeout(() => {
                            isGraphLoaded = true;
                            printReportButton.prop("disabled", false);
                            pdfReportButton.prop("disabled", false);
                        }, 400);
                        updatePrintValues();
                    }
                });

                // for (let stack in stackValues) {
                //   if (!isNaN(stackValues[stack])) {
                //     var stackClip = graph[stack];
                //     stackClip.coinArray = [];
                //     stackClip.stackValue = stackValues[stack];
                //     stackClip.labelAnimation.label.txt.text = "";
                //     const amountFontSize = graphWidth < 400 ? 22 : 18;
                //     stackClip.labelAnimation.label.txt.font = `bold ${amountFontSize}px Roobert-bold`;
                //     stackClip.gotoAndPlay(1);
                //   }
                // }

                // var tickListener = graph.on("tick", showLabels);
            });

            populateAccessibleResultsTable(results);
        });
    }
}

function changeInput() {
    const delayAnimation = setInterval(() => {
        if (animating === false) {
            clearInterval(delayAnimation);
            if (calculatedResults.stack4 === 0) {
                submitVolatilityStartAmount();
            } else {
                animating = true;
                isGraphLoaded = false;
                printReportButton.prop("disabled", true);
                pdfReportButton.prop("disabled", true);
                let newValue = formatter.parseNumber(document.getElementById("start-amount").value);

                if (newValue > 1000000 || newValue < 1 || isNaN(newValue) || !isInteger(newValue)) {
                    $(".volatility-err").show();
                    newValue = 0;
                } else {
                    $(".volatility-err").hide();
                }

                const volatilityPromise = new Promise((resolve) => {
                    getVolatilityResults(resolve, newValue);
                });
                // Print results on screen once promise is returned
                volatilityPromise.then((results) => {
                    const stackValues = {
                        stack1: Math.round((results.stack1 / results.stack4) * 35) || 0,
                        stack2: Math.round((results.stack2 / results.stack4) * 35) || 0,
                        stack3: Math.round((results.stack3 / results.stack4) * 35) || 0,
                        stack4: Math.round((results.stack4 / results.stack4) * 35) || 0 // ensuring that it returns a NaN on empty input
                    };

                    if (results.stack4 === 0) {
                        let counter = 35;
                        const interval = setInterval(() => {
                            if (counter < 1) {
                                setTimeout(() => {
                                    animating = false;
                                    isGraphLoaded = true;
                                    printReportButton.prop("disabled", false);
                                    pdfReportButton.prop("disabled", false);
                                }, 500);
                                updatePrintValues();
                                clearInterval(interval);
                            }
                            for (let i = 4; i > 0; i--) {
                                const stackClip = graph["stack" + i];
                                stackClip.labelAnimation.label.txt.text = "";
                                if (stackClip.coinArray[counter]) {
                                    const coin = stackClip.coinArray[counter];
                                    const oldStop = coin.stop;
                                    coin.stop = function () {
                                        this._reset();
                                        oldStop.call(this);
                                        this.stop = oldStop;
                                    };
                                    coin.gotoAndPlay(30);
                                }
                            }
                            counter--;
                        }, 66.66);
                    } else if (results.stack4 == calculatedResults.stack4) {
                        animating = false;
                        isGraphLoaded = true;
                        printReportButton.prop("disabled", false);
                        pdfReportButton.prop("disabled", false);
                        updatePrintValues();
                    } else if (results.stack4 <= calculatedResults.stack4) {
                        for (let i = 4; i > 0; i--) {
                            const stackClip = graph["stack" + i];
                            stackClip.labelAnimation.label.txt.text = "";
                            if (stackClip.coinArray) {
                                stackClip.coinArray[stackClip.coinArray.length - 1].gotoAndPlay(30);
                            }
                        }
                        setTimeout(showLabels, 500, results, calculatedResults);
                    } else {
                        for (let i = 4; i > 0; i--) {
                            const stackClip = graph["stack" + i];
                            stackClip.labelAnimation.label.txt.text = "";
                            if (stackClip.coinArray) {
                                stackClip.coinArray[stackClip.coinArray.length - 1].gotoAndPlay(0);
                            }
                        }
                        setTimeout(showLabels, 500, results, calculatedResults);
                    }

                    function showLabels(results, calculatedResults) {
                        for (let stack in stackValues) {
                            var stackClip = graph[stack];
                            if (results.stack4 < calculatedResults.stack4) {
                                stackClip.labelAnimation.y =
                                    stackClip.children[stackClip.children.length - 3].instance.y - 70;
                            } else {
                                stackClip.labelAnimation.y =
                                    stackClip.children[stackClip.children.length - 2].instance.y - 70;
                            }
                            const amountFontSize = graphWidth < 400 ? 23 : 18;
                            stackClip.labelAnimation.label.txt.font = `bold ${amountFontSize}px Roobert-bold`;
                            stackClip.labelAnimation.label.txt.text = formatter.formatCurrency(results[stack], 0);
                            stackClip.labelAnimation.gotoAndPlay(0);
                        }
                        animating = false;
                        isGraphLoaded = true;
                        printReportButton.prop("disabled", false);
                        pdfReportButton.prop("disabled", false);
                        updatePrintValues();
                    }

                    calculatedResults = results;

                    populateAccessibleResultsTable(results);
                });
            }
        }
    }, 200);
}

function populateAccessibleResultsTable(results) {
    $(".thirty-days-value").html(formatter.formatCurrency(Math.round(results.stack1)));
    $(".twenty-days-value").html(formatter.formatCurrency(Math.round(results.stack2)));
    $(".ten-days-value").html(formatter.formatCurrency(Math.round(results.stack3)));
    $(".continuously-invested-value").html(formatter.formatCurrency(Math.round(results.stack4)));
}

function setInputMaxLength() {
    const value = getValueFromInput("[name='startAmount']");
    let maxLength;

    if (value.indexOf(".") > -1) {
        maxLength = 9;
    } else {
        maxLength = 7;
    }

    $("[name='startAmount']").attr("maxlength", maxLength);
}

function restrictCurrencyInput() {
    $("input").on("keyup", function (event) {
        const name = $(this).attr("name");
        const value = getValueFromInput(`[name=${name}]`);

        if (name === "startAmount") {
            let finalValue = value;

            if ((finalValue.match(/\./g) || []).length >= 2 && event.key === ".") {
                finalValue = finalValue.slice(0, finalValue.length - 1);
            }

            if (finalValue.indexOf(".") > -1) {
                const decimalByParts = finalValue.split(".");
                const beforeDecimal = decimalByParts[0];
                const afterDecimal = decimalByParts[1].slice(0, 2);
                finalValue = `${beforeDecimal}.${afterDecimal}`;
            }

            $(this).val(finalValue);
        }
        setInputMaxLength();
    });
}

function updatePrintValues() {
    const startingAmount = formatter.parseNumber($("#start-amount").val());
    const graphSrc = $("canvas").get(0).toDataURL();

    storePrintValues({ graphSrc, startingAmount });
}

function scrollNav() {
    const nav = $("#pgNav");
    const width = nav.width() + 500;
    nav.scrollLeft(width);
}

const volatilityGraphDebounced = debounce(changeInput, 500);

function unhideIcon() {
    $("#pgNavTaggle").on("click", () => {
        $(".fa-chevron-up").css("display", "");
    });
}

$(() => {
    if (window.location.search === "?pdf") {
        setupPreview();
        return;
    }

    // reset form input values on IE browser refresh
    document.getElementById("volatility-form").reset();

    buildVolatility();
    submitVolatilityStartAmount();
    setUpNumericInputs();
    fillFieldsOnBlur();
    disableFormSubmitOnEnter();
    setInputMaxLength();
    restrictCurrencyInput();
    setUpButtons();
    scrollNav();
    unhideIcon();

    window.onresize = () => {
        graphWidth = $(".graph-container").width();
        scrollNav();
    };
    $("#start-amount").on("change keyup", volatilityGraphDebounced);
});
